import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import AgentPage from "@/pages/AgentPage";

export const Route = createFileRoute("/pl/agent")({
  head: () => routeHead('Agent AI AGAPE — Wypróbuj asystenta', META_DESCRIPTIONS.agent.pl, '/pl/agent'),
  component: AgentPage,
});
